<div
  class="tooltip-container"
  [ngClass]="type"
  (click)="clickTooltip && clickTooltip.emit()"
>
  <!-- Tooltip Pointer -->
  <ng-container *ngIf="!tooltip.hidePointer">
    <div class="pointer" [ngClass]="tooltip.pointerDirection"></div>
  </ng-container>

  <!-- Dismiss Icon -->
  <ng-container *ngIf="closeIcon">
    <i2g-icon
      class="close-button"
      [icon]="closeIcon"
      (click)="dismissTooltip.emit()"
    >
    </i2g-icon>
  </ng-container>

  <!-- Title & Description -->
  <div
    *ngIf="tooltip.title"
    class="title"
    [innerHTML]="tooltip.title | safe: 'html'"
  ></div>
  <div
    *ngIf="tooltip.description"
    class="description"
    [innerHTML]="tooltip.description | safe: 'html'"
  ></div>

  <!-- Next & Progress -->
  <div class="next-progress" [ngClass]="{ visible: showNext || progressText }">
    <div *ngIf="showNext" [style.display]="showNext ? '' : 'none'" class="next">
      {{
        (isLastInSequence
          ? 'ONBOARDING_TOOLTIP.DONE'
          : 'ONBOARDING_TOOLTIP.NEXT'
        ) | translate
      }}
    </div>
    <div *ngIf="progressText" [style.display]="progressText ? '' : 'none'">
      {{ progressText }}
    </div>
  </div>
</div>
